import React from "react";

export function PortalPanel({ title, description, children, className = "" }) {
  return (
    <div className={`portal-panel ${className}`.trim()}>
      {title || description ? (
        <div className="portal-panel__header">
          {title ? <h2 className="portal-panel__title">{title}</h2> : null}
          {description ? <p className="portal-panel__description">{description}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
